import React from 'react';
import './Login.css';
import { useNavigate } from "react-router-dom";
import { useState } from 'react';
import { MDBContainer, MDBCol, MDBRow, MDBBtn, MDBInput} from 'mdb-react-ui-kit';
import Navbar from '../Navbar.js';
import LoginPageImage from '../Images/LoginPageImage.PNG';

//DialogBox Imports
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle'

export default function InternalUserLogin() {
    const navigate = useNavigate();
    const [userName, setUserName] = useState('')
    const [password, setPassword] = useState('')
    const [errorUserNameField, setErrorUserNameField] = useState(null);
    const [errorPasswordField, setErrorpasswordField] = useState(null);

    const handleSubmit = event => {
        console.log("asyncPostVerifyOtpCall() method executing..");

        setErrorUserNameField(null);
        setErrorpasswordField(null);
        if (userName === '') { //EmailId is empty
            setErrorUserNameField('Username Field cannot be empty!');
            event.preventDefault();
        } else if (password === '') {
            setErrorpasswordField('Password field cannot be empty!');
            event.preventDefault();
        }
        else { //Otp field is Valid and non empty
            asyncPostLoginInternalUserCall();
        }
    }

     const handleSubmitEnterPressed = (e) => {
        if (e.keyCode == 13 && e.shiftKey == false) {
            console.log("Enter key is pressed.. submitting the form.")
            asyncPostLoginInternalUserCall();
        }
    }

    const asyncPostLoginInternalUserCall = async () => {
        const specialCharsForUserName = /[`!@#$%^&*()_+\-=\[\]{};.':"\\|,<>\/?~]/;
        if (specialCharsForUserName.test(userName)) {
            setErrorUserNameField("Invalid Username!")
        }
        else {
            try {
                const strLoginInternalUserUrl = 'home/loginInternalUser';

                //console.log("strLoginInternalUserUrl = " + strLoginInternalUserUrl);
                await fetch(strLoginInternalUserUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        UserName: userName,
                        Password: password
                    })
                }).then(response => {
                    //console.log("res", response)
                    return response.text()
                })
                    .then(data => {
                        //console.log("dataa", data);
                        //Logic change..
                        if (String(data)!=="") {
                            //var user = '@HttpContext.Session.GetString("EMPCODE")';
                            asyncGetEmployeeCodeByUsername();
                            sessionStorage.setItem("jwt", data);


                        } else {
                            // enter your logic - when there is an error (eg. error toast)
                            alert("Invalid Username or Password!")
                        }
                    })
                    //.then(function (data) { // data => contains true/false as a response of an API call
                    //const respData = data;
                    //console.log("data : " + data);
                    ////Logic change..
                    //if (data.match("true")){
                    //    alert("Successfully registered")
                    //    navigate("/GrievanceDashboard")
                    //} else {
                    //    // enter your logic - when there is an error (eg. error toast)
                    //    alert("Something went wrong")
                    //}

                    //}
                    ;
            } catch (error) {
                console.log(error)
            }
        }
    }


    const asyncGetEmployeeCodeByUsername = async () => {
        const strGetEmpCodeUrl = 'home/getEmployeeCode';

        await fetch(strGetEmpCodeUrl, {
            method: 'POST'
        }).then(response => {
            //console.log("res", response)
            return response.text()
        }).then(data => {
            if (data) {
                sessionStorage.setItem("InternalUserId", data);
                sessionStorage.setItem("InternalUserName", userName);

                //console.log("SESSION : ");
                //console.log(sessionStorage);
                navigate("/GrievanceDashboard")
                /*Show Grievance Summary dialog for Internal User*/
                handleClickOpen()
            }
        })
    }
    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    
    return (
        <MDBContainer fluid className="p-3 my-5 h-custom" >
            <Navbar />
            <Dialog
                open={open}
                onClose={handleClose}
                scroll='paper'
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description" >
                <DialogTitle id="scroll-dialog-title">DEPT-NAME : Grievance Summary</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                    {/*<DialogContentText*/}
                    {/*    id="scroll-dialog-description"*/}
                    {/*    ref={descriptionElementRef}*/}
                    {/*    tabIndex={-1}  >*/}
                    {/*    <div class="grid-container">*/}
                    {/*    <span class="nav-bg-col grid-item" col='2'> Number of pending grievances</span>*/}
                    {/*        <div class="grid-item"> 5</div>*/}
                    {/*        <div class="grid-item"> Number of <p className="">Ticket Number :</p></div>*/}
                    {/*        <div class="grid-item"> <p className="bold"></p></div>*/}

                    {/*</div>*/}
                    <table class="table bg-white ">

                        <tbody>
                            <tr>
                                <th className="bold"><p>Number Of Pending Grievances -</p></th><td >1</td>
                            </tr>
                            <tr>
                                <th className="bold"><p>Total Unacknowledged Grievances -</p></th><td>6</td>
                            </tr>
                            <tr>
                                <th className="bold"><p>Closed Grievances -</p></th><td>10</td>
                            </tr>
                            <tr>
                                <th className="bold"><p>Resolved Grievances :</p></th><td>21</td>
                            </tr>
                            <tr>
                                <th className="bold"><p>In-progress Grievances :</p></th><td>20</td>
                            </tr>
                        </tbody>
                    </table>

                    {/*</DialogContentText>*/}

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} >NEXT</Button>
                </DialogActions>
            </Dialog>
            <MDBRow>

                <MDBCol col='10' md='6'>
                {/*//https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp*/}
                    <img src={LoginPageImage} class="img-fluid" alt="Sample image" />
                </MDBCol>

                <MDBCol col='4' md='6'>


                    <div className="divider d-flex align-items-center my-4">
                        <p className="text-center fw-bold mx-3 mb-0">Internal User Login</p>
                    </div>
                    {/*Valid CCIL Email Id/Employee No*/}

                    <MDBInput wrapperClass='mb-4' onChange={(e) => setUserName(e.target.value)} label='Employee User Name' id='formControlLg'  size="lg" />
                    {errorUserNameField && <p className="d-flex align-items-left my-4" style={{ color: 'red' }}>{errorUserNameField}</p>}
                    <MDBInput wrapperClass='mb-4' onChange={(e) => setPassword(e.target.value)} onKeyDown={handleSubmitEnterPressed} label='Password' id='formControlLg' type='password' size="lg" />
                    {errorPasswordField && <p className="d-flex align-items-left my-4" style={{ color: 'red' }}>{errorPasswordField}</p>}

                    {/*Submit btn*/}

                    <div className='text-center text-md-start mt-4'>
                        <p className="small fw-bold mt-2 pt-1 mb-2">* Login to the Grievance Redressal Portal using your Windows System Credentials</p>
                        <br/>
                        <MDBBtn className="mb-0 px-5" size='lg' onClick={handleSubmit}>Submit</MDBBtn>
                        <p className="small fw-bold mt-2 pt-1 mb-2"><a href="/Register" className="link-danger">Register ?</a></p>
                    </div>

                </MDBCol>

            </MDBRow>
        </MDBContainer >
    );
}
